// For dev, enable redux dev tool
export default process.env.NODE_ENV === 'development' && // Is in development mode
window.__REDUX_DEVTOOLS_EXTENSION__ // Browser has devtools extension
  ? window.__REDUX_DEVTOOLS_EXTENSION__()
  : f => f;
